import React from 'react'
import tw from "twin.macro";
import styled from "styled-components";
import aws_logo from "../../../Images/aws_logo.png";
import gcp_logo from "../../../Images/gcp_logo.png";
import azure_logo from "../../../Images/azure_logo.png";


const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const Card = tw.div`flex flex-col md:flex-row justify-center max-w-screen-xl mx-auto my-5`;
const ImageRow = tw.div`flex flex-row md:flex-row justify-center max-w-screen-xl mx-auto pt-0 pb-0`;
const ImageSpan = tw.span`lg:mx-5 md:mx-5 sm:mx-5 ml-1 mr-1`;
const ImageColumn2 = tw(
  Column
)`rounded-full bg-gray-200 w-10 p-0 sm:p-3 sm:w-24 lg:p-2 mb-5 mt-3 lg:w-20 md:w-24 md:p-2 xs:w-18 xs:p-0 items-end sm:items-start xs:items-start`;
const Image = styled.img((props) => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
  tw(
    Column
  )`rounded-full bg-gray-200 w-32 p-4 sm:p-3 sm:w-24 lg:p-4 my-5 lg:w-32 md:w-24 md:p-3 xs:w-12 xs:p-1`,
]);
const Title = tw.p`-mt-4 text-sm text-center xs:mx-auto`;
const Container = tw.div`bg-blue-100 pb-1 w-full text-center `;
const Heading = tw.h5`text-2xl font-bold text-gray-900`;
const SubHeading = tw.p`text-base text-gray-700 sm:text-lg`;

let cards = {
  logo1: "Amazon",
  logo3: "Microsoft",
  logo2: "Google",
  heading: "Cloud-hosted web applications built using contemporary technologies and tools.",
  subheading: "Reliable and dedicated support, maintenance and upgrades for your legacy systems."
}

const CloudLogoCard = () => {


  let  imageSrc1 = aws_logo,
        imageSrc2 = gcp_logo,
        imageSrc3 = azure_logo,
        imageRounded = true,
        imageBorder = false,
        imageShadow = false
  return (
        
    <Card>
    <Container >
       <ImageRow>
        <ImageSpan>
           <ImageColumn2>
             <Image
              src={imageSrc1}
              imageBorder={imageBorder}
              imageShadow={imageShadow}
              imageRounded={imageRounded}
              alt="aws_logo"
            />
          </ImageColumn2>
          <Title>{cards.logo1}</Title>
        </ImageSpan>
        <ImageSpan>
          <ImageColumn2>
            <Image
              src={imageSrc2}
              imageBorder={imageBorder}
              imageShadow={imageShadow}
              imageRounded={imageRounded}
              alt="azure_logo"
            />
          </ImageColumn2>
          <Title>{cards.logo2}</Title>
        </ImageSpan>
        <ImageSpan>
          <ImageColumn2>
            <Image
              src={imageSrc3}
              imageBorder={imageBorder}
              imageShadow={imageShadow}
              imageRounded={imageRounded}
              alt="gcp_logo"
            />
          </ImageColumn2>
          <Title>{cards.logo3}</Title>
        </ImageSpan>
      </ImageRow>
      <Heading>
       {cards.heading}
      </Heading>
      <SubHeading >
      {cards.subheading}
      </SubHeading>
    </Container>
  </Card>
  )
}

export default CloudLogoCard